import {all, call, fork, put, select, takeLatest} from 'redux-saga/effects';
import * as constants from '../constants';
import * as api from '../services/api';
import {logout} from '../actions/action_auth';
import {fetchSurveyTagsSuccess, fetchSurveyTagsFailure} from '../actions/action_survey';

function* watchFetchTags() {
    yield takeLatest(constants.SURVEY_TAGS_REQUESTED, function* ({payload}) {
        try {
            const organizationId = yield select((state) => state.organization.current && state.organization.current.id);
            const response = yield call(api.fetchSurveyTagsSuggestions, organizationId, payload.text);
            yield put(fetchSurveyTagsSuccess(response.data));
        } catch (error) {
            if (error.response && error.response.status === 401) {
                yield put(logout());
            }
            yield put(fetchSurveyTagsFailure(error));
        }
    });
}

export default function* root() {
    yield all([
        fork(watchFetchTags),
    ]);
}
